import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import './Layout.css';

function Layout() {
    const { client, logout } = useAuth();
    const { language, toggleLanguage, t, isRTL } = useLanguage();
    const location = useLocation();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const isActive = (path) => {
        if (path === '/dashboard') return location.pathname === '/dashboard';
        if (path === '/tickets/new') return location.pathname === '/tickets/new';
        if (path === '/tickets') return location.pathname === '/tickets' || (location.pathname.startsWith('/tickets/') && location.pathname !== '/tickets/new');
        return location.pathname.startsWith(path);
    };

    const getPageTitle = () => {
        if (location.pathname === '/dashboard') return t('dashboard');
        if (location.pathname === '/tickets') return t('myTickets');
        if (location.pathname === '/tickets/new') return t('createTicket');
        if (location.pathname.startsWith('/tickets/')) return t('ticketDetails');
        if (location.pathname === '/my-bookings') return language === 'ar' ? '\u0645\u0648\u0627\u0639\u064a\u062f\u064a' : 'My Bookings';
        if (location.pathname === '/book-meeting') return language === 'ar' ? '\u062d\u062c\u0632 \u0645\u0648\u0639\u062f' : 'Book Meeting';
        if (location.pathname === '/profile') return t('settings');
        return '';
    };

    return (
        <div className={`layout ${isRTL ? 'rtl' : 'ltr'}`}>
            <aside className="sidebar">
                <div className="sidebar-header">
                    <Link to="/dashboard" className="sidebar-logo">
                        <img src="/logo.png" alt="Matix" />
                        <span>Matix Helpdesk</span>
                    </Link>
                </div>

                <nav className="sidebar-nav">
                    <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>
                        <span className="nav-icon">🏠</span>
                        <span>{t('dashboard')}</span>
                    </Link>
                    <Link to="/tickets" className={`nav-link ${isActive('/tickets') ? 'active' : ''}`}>
                        <span className="nav-icon">📋</span>
                        <span>{t('myTickets')}</span>
                    </Link>
                    <Link to="/tickets/new" className={`nav-link ${isActive('/tickets/new') ? 'active' : ''}`}>
                        <span className="nav-icon">➕</span>
                        <span>{t('newTicket')}</span>
                    </Link>
                    <Link to="/profile" className={`nav-link ${isActive('/profile') ? 'active' : ''}`}>
                        <span className="nav-icon">⚙️</span>
                        <span>{t('settings')}</span>
                    </Link>
                    <Link to="/my-bookings" className={`nav-link ${isActive('/my-bookings') ? 'active' : ''}`}>
                        <span className="nav-icon">📅</span>
                        <span>{language === 'ar' ? 'حجز موعد' : 'My Bookings'}</span>
                    </Link>
                    <Link to="/contracts" className={`nav-link ${isActive('/contracts') ? 'active' : ''}`}>
                        <span className="nav-icon">📋</span>
                        <span>{language === 'ar' ? 'عقودي' : 'My Contracts'}</span>
                    </Link>
                </nav>

                <div className="sidebar-footer">
                    <button onClick={toggleLanguage} className="lang-btn">
                        🌐 {language === 'ar' ? 'English' : 'العربية'}
                    </button>
                    <button onClick={handleLogout} className="logout-btn">
                        <span className="nav-icon">🚪</span>
                        <span>{t('logout')}</span>
                    </button>
                </div>
            </aside>

            <main className="main-content">
                <header className="header">
                    <div className="header-title">
                        <h2>{getPageTitle()}</h2>
                    </div>
                    <div className="user-menu">
                        <span className="user-name">{client?.name || 'User'}</span>
                        <div className="user-avatar">
                            {client?.name?.charAt(0)?.toUpperCase() || 'U'}
                        </div>
                    </div>
                </header>

                <div className="page-content">
                    <Outlet />
                </div>

                <footer className="footer">
                    <p>© 2024 MatixERP. {language === 'ar' ? 'جميع الحقوق محفوظة' : 'All rights reserved'}.</p>
                </footer>
            </main>
        </div>
    );
}

export default Layout;
